<script setup>
import { getLocalizedUrl } from '@js/App/Plugins/LocalizedUrls'
import { Link } from '@inertiajs/vue3'

defineProps({
  size: {
    type: String,
    default: 'md'
  },
  href: {
    type: [String, Boolean],
    default: () => getLocalizedUrl('rentbird-relocation')
  }
})

</script>
<template>
  <component
    :is="href ? Link : 'div'"
    :href="href"
    class="block"
  >
    <img
      src="../../../../assets/images/rentbird-relocation-logo.svg"
      :class="{
        'min-w-[130px] w-[130px]': size === 'md',
        'min-w-[110px] w-[110px]': size === 'sm',
        'min-w-[98px] w-[98px]': size === 'xs'
      }"
    >
  </component>
</template>
